module.exports = __webpack_public_path__ + "static/img/title-on-64px.a6903145.png";